import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Provider } from '../../models/provider.model';
import { AccessType } from '../../models/access-type.model';

@Component({
  selector: 'mprd-modem-choice-ont',
  templateUrl: './modem-choice-ont.component.html',
})
export class ModemChoiceOntComponent implements AfterViewInit {
  @Input() id = '';
  @Input() active = false;
  @Input() activable = false;
  @Input() provider: Provider = 'CUSTOMER';
  @Input() serialNumber = '';
  @Input() accessType: AccessType = 'GPON';
  @Output() activated = new EventEmitter<boolean>();
  @Output() edited = new EventEmitter<void>();
  @Output() deleted = new EventEmitter<void>();

  ngAfterViewInit(): void {
    // @ts-ignore: Inception exists, trust me.
    inception.actionMenu(document);
  }

  onActivation(): void {
    this.activated.emit(!this.active);
  }

  onEdit(): void {
    this.edited.emit();
  }

  onDelete(): void {
    this.deleted.emit();
  }
}
